import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VideosService {
  private videosRef: firebase.firestore.CollectionReference; 

  constructor() {
    this.videosRef = firebase.firestore().collection(`${environment.firestorePath}/videos`);
  }


  async getAllVideos(marca:string){
    try {
      const querySnapshot = await this.videosRef.where('marca',"==",marca).get();

      if (querySnapshot.empty) {
        throw new Error(`El endpoint no tiene registros...`);
      }
      
      const videos = querySnapshot.docs.map(doc => {
        const obj = doc.data();
        obj.id = doc.id;
        return obj;
      });

      return videos; 
    } catch (error) {
      throw new Error(error);
    }
  }
}
